import {CreateProductActions, CreateProductState} from "./types";

export const initialCreateProductState: CreateProductState = {
  currentCreateProductStep: "basicForm",
  formData: {
    bookingQuestions: [],
    description: "",
    hideFromProfile: false,
    isUrlRedirect: false,
    redirectAfterPurchase: "none",
    telegramGroupId: undefined,
    name: "",
    requestCustomerPhoneNumber: false,
    limitUnitsPerTransaction: false,
    purchaseLimit: undefined,
    url_redirect: undefined,
    coverImage: "",
    priceType: "paid",
    currencies: [],
  },
  apiResponseData: null,
  variantFormData: {
    showVariants: false,
    variants: [
      {
        variant_id: undefined,
        name: "",
        options: [
          {
            variant_option_id: undefined,
            name: "Option 1",
            priceType: "paid",
            currencies: [
              {
                price: 100,
                currency: "NGN",
              },
            ],
          },
        ],
      },
    ],
  },
  createdAddOns: [],
};

export function createInitialCreateProductReducerStateFromApi(args: {
  bankConnected: boolean;
  defaultCurrency: string; // e.g. currencyContextState.formCurrencies[0]
}): CreateProductState {
  const priceType = args.bankConnected ? "paid" : "free";
  return {
    currentCreateProductStep: "basicForm",
    formData: {
      bookingQuestions: [],
      description: "",
      hideFromProfile: false,
      isUrlRedirect: false,
      redirectAfterPurchase: "none",
      telegramGroupId: undefined,
      name: "",
      requestCustomerPhoneNumber: false,
      limitUnitsPerTransaction: false,
      purchaseLimit: undefined,
      url_redirect: undefined,
      coverImage: "",
      priceType, // seeded once
      currencies: [
        {
          callPrice: 100,
          callPriceCurrency: args.defaultCurrency,
        },
      ],
    },
    apiResponseData: null,
    variantFormData: {
      showVariants: false,
      variants: [
        {
          variant_id: undefined,
          name: "",
          options: [
            {
              variant_option_id: undefined,
              name: "Option 1",
              priceType,
              currencies: [
                {
                  price: 100,
                  currency: "NGN",
                },
              ],
            },
          ], // mirror initial default only
        },
      ],
    },
    createdAddOns: [],
  };
}

export const createProductReducer = (
  state: CreateProductState = initialCreateProductState,
  action: CreateProductActions
) => {
  if (action.type === "update-create-product-form-step") {
    return {...state, currentCreateProductStep: action.payload};
  }

  if (action.type === "save-create-product-form-values") {
    return {
      ...state,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
  }

  if (action.type === "save-create-product-api-response") {
    return {
      ...state,
      apiResponseData: action.payload.apiResponseData,
    };
  }
  // if (action.type === "go-to-basic-form-step") {
  //   const yo = {
  //     ...state,
  //     currentCreateProductStep: "basicForm" as CreateProductSteps,
  //     formData: {
  //       ...state.formData,
  //       ...action.payload,
  //     },
  //   };
  //   return yo;
  // }
  // if (action.type === "go-to-checkout-form-step") {
  //   const yo = {
  //     ...state,
  //     currentCreateProductStep: "checkoutForm" as CreateProductSteps,
  //     formData: {
  //       ...state.formData,
  //       ...action.payload,
  //     },
  //   };
  //   return yo;
  // }
  // if (action.type === "go-to-cover-images-upload-form-step") {
  //   const yo = {
  //     ...state,
  //     currentCreateProductStep: "coverImagesUpload" as CreateProductSteps,
  //     formData: {
  //       ...state.formData,
  //       ...action.payload.formData,
  //     },
  //     apiResponseData: action.payload.apiResponse,
  //   };
  //   return yo;
  // }
  // if (action.type === "go-to-content-upload-form-step") {
  //   const yo = {
  //     ...state,
  //     currentCreateProductStep: "contentUpload" as CreateProductSteps,
  //   };
  //   return yo;
  // }
  // if (action.type === "go-to-variant-form-step") {
  //   const yo = {
  //     ...state,
  //     currentCreateProductStep: "variantForm" as CreateProductSteps,
  //   };
  //   return yo;
  // }
  if (action.type === "save-variant-form-step-data") {
    const yo = {
      ...state,
      variantFormData: action.payload,
    };
    return yo;
  }
  if (action.type === "save-created-add-ons") {
    return {
      ...state,
      createdAddOns: action.payload,
    };
  }
  if (action.type === "reset-state") {
    const yo = {...initialCreateProductState};
    return yo;
  }

  return state;
};
